export default "__VITE_ASSET__6cbc7fde__"